import React, {Fragment} from "react";
import SFXButtonComponent from "./SFXButtonComponent";
import UserSessionService from "../services/UserSessionService";
import AgentPrivilege from "../enum/AgentPrivilege";

export default class CardDataComponent extends React.Component {

    constructor(props) {
        super(props);

        this.agentCanViewBankAccounts = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_BANK_ACCOUNT_VIEW);

        this.state = {
            config: this.props.config !== undefined ? this.props.config : [],
            data: this.props.data !== undefined ? this.props.data : [],
            buttonConfig: this.props.buttonConfig !== undefined ? this.props.buttonConfig : []
        }
    };

    render() {
        return <Fragment>

            {this.state.config.map((value, index) => {
                return <Fragment key={index}>
                    <h6>{value.label}</h6>
                    <h6 style={{color: "grey"}}>{this.state.data[value.dataField]}</h6>
                </Fragment>
            })}

            {this.agentCanViewBankAccounts && this.renderBankAccountDetails()}

            <hr/>
            {
                this.state.buttonConfig.map((singleButton, index) => {
                    return <Fragment key={index}>
                        <SFXButtonComponent color={"primary"}
                                            onClick={singleButton.buttonFunction}
                        >{singleButton.buttonText}
                        </SFXButtonComponent>
                        {'    '}
                    </Fragment>
                })
            }
        </Fragment>

    }

    renderBankAccountDetails() {
        return this.props.bankAccountDetails ? <Fragment>
                <h6>{'Account Status'}</h6>
                <h6 style={{color: "grey"}}>{this.props.bankAccountDetails.accountStatus}</h6>

                <h6>{'Has Bank card'}</h6>
                <h6 style={{color: "grey"}}>{(this.props.bankAccountDetails.hasActiveBankCard
                    ? <span style={{color: "green", fontSize: "10pt"}}><i className={"fa fa-check"}/></span>
                    : <span style={{color: "red", fontSize: "10pt"}}><i className={"fa fa-times"}/></span>)}</h6>
            </Fragment>
            :
            <Fragment>
                <h6>{'Account Status'}</h6>
                <h6 style={{color: "grey"}}>{'No Bank Account'}</h6>

                <h6>{'Has Bank card'}</h6>
                <h6 style={{color: "grey"}}>{<span style={{color: "red", fontSize: "10pt"}}><i className={"fa fa-times"}/></span>}</h6>
            </Fragment>
    }

}
